'use client';

import FeedbackButton from '@/layers/presentation/components/common/FeedbackButton';
import { UserTypePrompt } from '@/layers/presentation/components/common/UserTypePrompt';
import PageTransition from '@/layers/presentation/components/utils/PageTransition';
import NotificationBoundary from '@/layers/presentation/components/utils/NotificationBoundary';
import { AuthProvider } from '@/layers/presentation/context/AuthContext';
import { GlobalStateProvider } from '@/layers/presentation/context/GlobalStateContext';
import { IntercomProvider } from '@/layers/presentation/context/IntercomContext';
import { NotificationProvider } from '@/layers/presentation/context/NotificationContext';
import { I18nProvider } from '@/layers/presentation/i18n/provider';
import { OnboardingProvider } from '@/layers/presentation/providers/OnboardingProvider';
import { SubscriptionModalProvider } from '@/layers/presentation/providers/SubscriptionModalProvider';
import { NextUIProvider } from '@nextui-org/react';
import React from 'react';

export function AppProviders({ children }: { children: React.ReactNode }) {
  return (
    <I18nProvider lng="en">
      <GlobalStateProvider>
        <AuthProvider>
          <OnboardingProvider>
            <NextUIProvider>
              <NotificationProvider>
                <NotificationBoundary>
                  <IntercomProvider>
                    <SubscriptionModalProvider>
                      <PageTransition>{children}</PageTransition>
                      <FeedbackButton />
                      <UserTypePrompt />
                    </SubscriptionModalProvider>
                  </IntercomProvider>
                </NotificationBoundary>
              </NotificationProvider>
            </NextUIProvider>
          </OnboardingProvider>
        </AuthProvider>
      </GlobalStateProvider>
    </I18nProvider>
  );
}
